import React,{useEffect, useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import { Dropdown, Modal } from 'react-bootstrap';
import { useGrade } from '../../../context/GradeContext';
import Form from 'react-bootstrap/Form';
import axios from '../../../interceptor/axios-config';
import Swal from 'sweetalert2';
import { useAssessmentData } from '../../../context/AssessmentContext';
import config from '../../../config';


const initialFormData = {
        section:'', assessment_name:'', total_mark:'', date_of_exam:''
    };

const Assessment = () => {

    const { assessmentData, loadingAssessment, loadAssessmentData } = useAssessmentData();

    //Year input

    const now = new Date();
    const year = String(now.getFullYear());

    const [yearInput, setYearInput] = useState(year);

    console.log(assessmentData);
    function getYearInput(e){
        setYearInput(e.target.value);
    }

    let filteredAssessment = [];
    if(assessmentData.length > 0){
        filteredAssessment = assessmentData.filter(ay => ay.academic_year === `${yearInput}`);
    }

    console.log(assessmentData);

    const records = [];
    let loading = true;
    let slno = 1;

    const studentsData =[];
    const selectedData =[];

    const [assessmentModal, setAssessmentModal] = useState(false);

    const [formData, setFormData] = useState(initialFormData);

    const handleChange = (e) => {
        const { name, value } = e.target;  
        setFormData({ ...formData, [name]: value });        
    };

    const closeAssessmentModal = () =>{
        setFormData(initialFormData);
        setAssessmentModal(false);
    }

    const handleSubmit = async (event) => {
        try {
          event.stopPropagation();
            if(formData.section !=='' && formData.assessment_name !=='' && formData.date_of_exam !==''){
                    const addAssessment = await axios.post(
                        `${config.apiBaseUrl}/assessment/addAssessment.php`,
                        formData
                    );            
                    console.log(addAssessment.data);
                    closeAssessmentModal();
                    loadAssessmentData();
                    Swal.fire({
                        icon: 'success',
                        title: 'Assessment has been created',
                        text: 'New Assessment has been created successfully',
                    });
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops! Required fields are missing',
                        text: 'Please fill up the required fields and try again',
                    });
                }
        } catch (error) {
          console.error('POST request error:', error);
          // Handle errors for both requests here
        }
      };

    return (
            <>
                <div className="row">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="mb-0">Assessments for Academic Year {yearInput}</h5>
                            <div className='d-flex'>
                                <input size="sm" style={{width:'120px'}}                                               
                                    type="text" 
                                    value={yearInput}
                                    className="form-control" 
                                    id="exampleFormControlInput7"  
                                    onChange={getYearInput}
                                />
                                <span className="p-1"></span>
                                {/* <Form.Select size="sm" style={{width:'120px'}} value={selectedGrade} onChange={handleClassSelection}> */}
                                {/* <Form.Select size="sm" style={{width:'120px'}}>
                                    <option value="all">---All---</option>
                                    {grade.map((item) => <option value={item.class_options}>{item.class_label}</option>)}
                                </Form.Select>
                                <span className="p-1"></span>   */}
                                {/* <button type="button" className="btn btn-primary" onClick={() => childRef1.current.openModal()}> */}
                                <button type="button" className="btn btn-primary" onClick={()=> setAssessmentModal(true)}>
                                    + New Assessment
                                </button>
                                <span className='p-1'></span>
                                {/* <button type="button" className="btn btn-success" onClick={refreshData} disabled={loading}> */}
                                <button type="button" className="btn btn-success" onClick={loadAssessmentData}>
                                    Reload
                                </button>
                            </div>
                        </div>
                        {loadingAssessment ? (
                            <p>Please wait , while data is being populated...</p>
                        ) : (
                            <div>
                        {filteredAssessment.length > 0
                        ?
                        (<div className="card-body">
                            <div className="row">
                            <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                                <div className="table-responsive full-data">
                                    <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                        <table className="table-responsive-lg table display dataTablesCard student-tab dataTable no-footer" subject_id="example-student">
                                            <thead>
                                                <tr>
                                                    <th>Sl No</th>
                                                    <th>Examination</th>
                                                    <th>Total Mark</th>
                                                    <th>Section</th>
                                                    <th>Schedued On</th>
                                                    <th>Added On</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredAssessment.map((item)=>(                                
                                                    <tr key={item.assessment_name}>
                                                        
                                                        <td>
                                                            <div className="trans-list">
                                                                <h4>{slno++}</h4>
                                                            </div>
                                                        </td>
                                                        <td><h6 className="mb-0">{item.assessment_name}</h6></td>
                                                        <td><h6 className="mb-0">{item.total_mark}</h6></td>
                                                        <td><h6 className="mb-0">{item.section}</h6></td>
                                                        <td><h6 className="mb-0">{item.date_of_exam}</h6></td>
                                                        <td><h6 className="mb-0">{item.added_on}</h6></td>
                                                        <td>
                                                            <div className="d-flex">
                                                                {/* <div className="icon-box icon-box-sm bg-light me-2">
                                                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" onClick={() => childRef2.current.openModal(item.subject_id)} ><path d="M120-120v-320h80v184l504-504H520v-80h320v320h-80v-184L256-200h184v80H120Z"/></svg>
                                                                </div> */}
                                                                <div className="icon-box icon-box-sm bg-light me-2">
                                                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M200-200h56l345-345-56-56-345 345v56Zm572-403L602-771l56-56q23-23 56.5-23t56.5 23l56 56q23 23 24 55.5T829-660l-57 57Zm-58 59L290-120H120v-170l424-424 170 170Zm-141-29-28-28 56 56-28-28Z"/></svg>
                                                                </div>
                                                                <div className="icon-box icon-box-sm bg-light">
                                                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" ><path d="M600-240v-80h160v80H600Zm0-320v-80h280v80H600Zm0 160v-80h240v80H600ZM120-640H80v-80h160v-60h160v60h160v80h-40v360q0 33-23.5 56.5T440-200H200q-33 0-56.5-23.5T120-280v-360Zm80 0v360h240v-360H200Zm0 0v360-360Z"/></svg>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>  
                                        {/* <div className="d-sm-flex text-center justify-content-between align-items-center">                           
                                        <div className='dataTables_info'>
                                            Showing {lastIndex-recordsPage + 1} to{" "}
                                            {subList.length < lastIndex ? subList.length : lastIndex}
                                            {" "}of {subList.length} entries
                                        </div>
                                        <div
                                            className="dataTables_paginate paging_simple_numbers justify-content-center"
                                            id="example-student_wrapper"
                                        >
                                            <Link
                                                className="paginate_button previous disabled"
                                                to="#"                                        
                                                onClick={prePage}
                                            >
                                                <i className="fa-solid fa-angle-left" />
                                            </Link>
                                            <span>                                      
                                                {number.map((n , i )=>(
                                                    <Link className={`paginate_button ${currentPage === n ? 'current' :  '' } `} key={i}                                            
                                                        onClick={()=>changeCPage(n)}
                                                    > 
                                                        {n}                                                

                                                    </Link>
                                                ))}
                                            </span>
                                            <Link
                                                className="paginate_button next"
                                                to="#"                                        
                                                onClick={nextPage}
                                            >
                                                <i className="fa-solid fa-angle-right" />
                                            </Link>
                                        </div>
                                    </div>    */}
                                    </div>
                                </div>  
                            </div> 
                            </div>
                        </div>)
                        :(<div className="card-body">
                            <div className="row">
                                <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s"> 
                                    <h3>No records found</h3>
                                </div>
                            </div>
                        </div>
                        )
                        }
                        </div>
                        )}
                    </div>
                </div>
            </div>  
            {/* modal section              */}
            <Modal className="modal fade"  show={assessmentModal} onHide={setAssessmentModal} centered>              
                <form >
                    <div className="modal-header">
                        <h4 className="modal-title fs-20">Assessment for Academic Year {year}</h4>
                        <button type="button" className="btn-close" onClick={closeAssessmentModal}></button>
                    </div>
                    <div className="modal-body">
                        <div className="add-contact-box">
                            <div className="add-contact-content">       
                                    <div className="file-input w-full px-9 mb-1 md:mb-0">
                                        <label className="form-label text-primary" htmlFor="grid-first-name">
                                            Sections
                                        </label>
                                        <div className='flex'>
                                            <label className="flex form-label text-primary p-2">
                                                <input
                                                    className='p-4'
                                                    type="radio"
                                                    name="section"
                                                    value="All"
                                                    checked={formData.section === 'All'}
                                                    onChange={handleChange}
                                                />
                                            <span className='p-2'>All</span>
                                            </label>
                                            <span className="p-2"></span>
                                            <label className="flex form-label text-primary p-2">
                                                <input
                                                    className='p-4'
                                                    type="radio"
                                                    name="section"
                                                    value="PP"
                                                    checked={formData.section === 'PP'}
                                                    onChange={handleChange}
                                                />
                                            <span className='p-2'>Pre Prime</span>
                                            </label>
                                            <span className="p-2"></span>
                                            <label className="flex form-label text-primary p-2">
                                                <input
                                                    className='p-4'
                                                    type="radio"
                                                    name="section"
                                                    value="LP"
                                                    checked={formData.section === 'LP'}
                                                    onChange={handleChange}
                                                />
                                            <span className='p-2'>LP</span>
                                            </label>
                                            <span className="p-2"></span>
                                            <label className="flex form-label text-primary p-2">
                                                <input
                                                    className='p-4'
                                                    type="radio"
                                                    name="section"
                                                    value="UP"
                                                    checked={formData.section === 'UP'}
                                                    onChange={handleChange}
                                                />
                                            <span className='p-2'>UP</span>
                                            </label>
                                            <span className="p-2"></span>
                                            <label className="flex form-label text-primary p-2">
                                                <input
                                                    className='p-4'
                                                    type="radio"
                                                    name="section"
                                                    value="SS"
                                                    checked={formData.section === 'SS'}
                                                    onChange={handleChange}
                                                />
                                            <span className='p-2'>IX & X</span>
                                            </label>
                                        </div>
                                </div>
                                <div className="file-input w-full px-9 mb-1 md:mb-0">
                                        <label className="form-label text-primary" htmlFor="grid-first-name">
                                            Total Mark
                                        </label>
                                        <div className="flex space-x-4"> {/* Added space between radio buttons */}
                                            {/* 25 Marks */}
                                            <label htmlFor="mark-25" className="flex items-center form-label text-primary p-2">
                                                <input
                                                    id="mark-25"
                                                    className="mr-2 p-4"
                                                    type="radio"
                                                    name="total_mark"
                                                    value="25"
                                                    checked={formData.total_mark === '25'}
                                                    onChange={handleChange}
                                                />
                                                <span>25</span>
                                            </label>

                                            {/* 50 Marks */}
                                            <label htmlFor="mark-50" className="flex items-center form-label text-primary p-2">
                                                <input
                                                    id="mark-50"
                                                    className="mr-2 p-4"
                                                    type="radio"
                                                    name="total_mark"
                                                    value="50"
                                                    checked={formData.total_mark === '50'}
                                                    onChange={handleChange}
                                                />
                                                <span>50</span>
                                            </label>

                                            {/* 100 Marks */}
                                            <label htmlFor="mark-80" className="flex items-center form-label text-primary p-2">
                                                <input
                                                    id="mark-80"
                                                    className="mr-2 p-4"
                                                    type="radio"
                                                    name="total_mark"
                                                    value="80"
                                                    checked={formData.total_mark === '80'}
                                                    onChange={handleChange}
                                                />
                                                <span>80</span>
                                            </label>

                                            {/* 100 Marks */}
                                            <label htmlFor="mark-100" className="flex items-center form-label text-primary p-2">
                                                <input
                                                    id="mark-100"
                                                    className="mr-2 p-4"
                                                    type="radio"
                                                    name="total_mark"
                                                    value="100"
                                                    checked={formData.total_mark === '100'}
                                                    onChange={handleChange}
                                                />
                                                <span>100</span>
                                            </label>
                                        </div>

                                </div>
                                <div className="form-group mb-3">
                                    <label className="text-black font-w500">Select Assessment</label>
                                    <div className="contact-occupation">                                        
                                        <Form.Select aria-label="Default select example" name="assessment_name"  value={formData.assessment_name} onChange={handleChange} required="required">
                                            <option>---Select assessment---</option>
                                            <option value='Internal-I'>First Internal</option>                                 
                                            <option value='Internal-II'>Second Internal</option>                                 
                                            <option value='HYE'>Half-Yearly</option>                                 
                                            <option value='ANE'>Annual</option>                                 
                                        </Form.Select>
                                    </div>
                                </div>
                                <div className="form-group mb-3">
                                    <label className="text-black font-w500">Date</label>
                                    <div className="contact-occupation">
                                        <input                                                     
                                            type="date" 
                                            className="form-control" 
                                            id="exampleFormControlInput7"                                                     
                                            name="date_of_exam"
                                            value={formData.date_of_exam}
                                            onChange={handleChange}
                                            required="required"
                                        />
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={handleSubmit}>Save</button>  
                        <button type="button" onClick={closeAssessmentModal} className="btn btn-danger"> <i className="flaticon-delete-1"></i> Discard</button>      
                    </div>
                </form>  
            </Modal>
        </>
    )
}

export default Assessment
